var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApertureGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4869 2.5C10.6779 2.5 8.97378 3 7.4794 3.81579L15.9213 9.97368L17.8876 4.05263C16.3146 3.10526 14.4532 2.5 12.4869 2.5ZM5.27715 5.47368C3.28464 7.39474 2 10.0526 2 13.0526C2 13.7105 2.05243 14.3158 2.1573 14.9474L10.2584 9.10526L5.25094 5.47368H5.27715ZM20.0375 5.81579L16.839 15.6842H22.5805C22.7903 14.8421 23 13.9737 23 13.0526C23 10.2368 21.8464 7.71053 20.0375 5.81579ZM7.66292 14.2895L3.07491 17.5789C4.51685 20.5526 7.26966 22.8158 10.6255 23.4211L7.66292 14.2895ZM11.7528 18.3158L13.4045 23.5C16.8914 23.1842 19.8539 21.1842 21.5056 18.3158H11.7528Z",
    fill: "#126973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApertureGreen);
export default __webpack_public_path__ + "static/media/icon-aperture-green.a1fa492e289dbc92433ffaf98caac664.svg";
export { ForwardRef as ReactComponent };